import posthog from 'posthog-js';
import { POSTHOG_HOST, POSTHOG_KEY } from '@/constants/env';

let isInitialized = false;

export function initPostHog() {
  if (isInitialized || !POSTHOG_KEY || !POSTHOG_HOST) return;

  // Later posthog-js minors turn on web-vitals target attribution and dated
  // config snapshots (JSON-LD replay). Pin the current silent behavior.
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    defaults: 'unset',
    autocapture: true,
    capture_pageview: true,
    disable_session_recording: false,
    capture_performance: {
      web_vitals_attribution: false,
    },
    session_recording: {
      maskAllInputs: true,
    },
  });

  isInitialized = true;
}

export { posthog };
